import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import courseApi from 'src/api/course'
import customerApi from 'src/api/customer'
import { updateInventoryRecord } from './inventoryRecord'

// fetch customer orders by orderId
// First, create the order detail thunk
export const fetchCustomerOrderById = createAsyncThunk(
  'course_detail/fetchDetailsByOrderId',
  async (orderId) => {
    const detail = await courseApi.findCourseById(orderId)
    return detail
  }
)

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  detail: null,
  status: '',
  contect: null,
  serviceProgressList: null,
  serviceArray: null,
  serviceProgress: null,
  serviceFinshed: null,
  packageArray: null,
  servicePackageProgress: null,
  selectedIndex: null,
  cpid:null,
  details: {
    id: null,
    total: 0,
    courseProducts: [],
    paid: 0,
    paymentHistories: [],
  },
  seqfilterProps:null
}

const slice = createSlice({
  name: 'course_detail',
  initialState,
  reducers: {
    setCourseDetail(oldState, action) {      
      oldState.detail = action.payload
    },
    setSeqfilterProps(oldState, action) {      
      oldState.seqfilterProps = action.payload
    },

    setCpid(oldState,action) {
      oldState.cpid =action.payload
    },

    openModal(oldState) {
      oldState.isModalOpen = true
    },

    closeModal(oldState) {
      oldState.isModalOpen = false
      oldState.modalViewName = null
      oldState.modalViewParams = null
    },

    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload
    },

    setSelectedIndex(oldState, action) {
      oldState.selectedIndex = action.payload
    },

    setCustomerContect(oldState, action) {
      oldState.contect = action.payload
    },

    setCustomerServiceArray(OldState, action) {
      const serviceProgressList = action.payload
      const serviceArray = []
      const packageArray = []
      serviceProgressList.content.map((service, idx) => {
        let packageInnerArray = []
        service.courseProducts.map((item, index) => {
          if (item.product && item.product.category.parent.id !== 21) {
            // if (item.frontPackageId == null || item.frontPackageId == 0) {
              serviceArray.push({
                ...item,
                serviceDate: service.recordDateTime.slice(0, 10),
                serviceDateTime: service.recordDateTime,
                serviceTime: service.recordDateTime.slice(11, 19),
                // productId: -1,
              })
            // } else {
            //   // console.log('package item', item)
            //   packageInnerArray.push(item)
            // }
          } else if (item.packages) {
            packageInnerArray.push(item)
          }
        })
        if (packageInnerArray.length !== 0) {
          packageArray.push(packageInnerArray)
        }
      })


      const serviceProgress = []
      const serviceFinshed = []
      const packageProgress = []

      // create array for puchased incomplete service in progress
      for (var i = 0; i < serviceArray.length; i++) {
        serviceProgress.push(Array())
        serviceFinshed.push(serviceArray[i].courseRecords)
        serviceProgress[i].push({
          ...serviceArray[i],
          signatureCode: 0,
          comment: '',
          productId: serviceArray[i].product.id,
        })
      }

      // create array for puchased incomplete package in progress
      packageArray.map((packages, idx) => {
        packageProgress.push(Array())
        for (var i = 0; i < packages.length; i++) {

          if (packages[i].courseRecords) {
            packages[i].courseRecords.map((record) =>
              packageProgress[idx].push(record)
            )
          }

          // for (
          //   var j = packages[i].completedAmount;
          //   j < packages[i].amount;
          //   j++
          // ) {
          //   packageProgress[idx].push({
          //     ...packages[i],
          //     amount: j + 1,
          //     sigin: 0,
          //     needSign: true,
          //   })
          // }
          // packageProgress[idx].push(Array())
        }
      })

      OldState.serviceArray = serviceArray
      OldState.serviceFinshed = serviceFinshed
      OldState.serviceProgress = serviceProgress
      OldState.packageArray = packageArray
      OldState.servicePackageProgress = packageProgress
    },


    setCustomerServiceProgressList(oldState, action) {
      oldState.serviceProgressList = action.payload
    },   
  },

  // handle actions loading state
  extraReducers: {
    [fetchCustomerOrderById.pending]: (oldState, action) => {
      oldState.status = 'loading'
      oldState.loading = true
    },
    [fetchCustomerOrderById.fulfilled]: (oldState, action) => {
      oldState.status = 'succeeded'
      // fetched customer orders to the state
      oldState.detail = action.payload
      oldState.loading = false
    },
    [fetchCustomerOrderById.rejected]: (oldState, action) => {
      oldState.status = 'failed'
      oldState.error = action.error.message
    },
  },
})

export const reducer = slice.reducer

export const setCpid = (id) => (dispatch) => {
  dispatch(slice.actions.setCpid(id))
}

export const setCourseDetail = (detail) => (dispatch) => {
  dispatch(slice.actions.setCourseDetail(detail))
}

export const setSeqfilterProps = (seq) => (dispatch) => {
  dispatch(slice.actions.setSeqfilterProps(seq))
}

export const getCourseDetailById = (id) => async (dispatch) => {
  const detail = await courseApi.findCourseById(id)
  dispatch(slice.actions.setCourseDetail(detail))
}

// Course Customer
// courseCustomerDto = {
//   "birthday": "string",
//   "firstName": "string",
//   "lastName": "string",
//   "phone": "string",
//   "refId": "string"
// }
export const editCustomerInfo = (courseId, courseCustomerDto) => async (
  dispatch
) => {
  const detail = await courseApi.editCustomerInfoThought(
    courseId,
    courseCustomerDto
  )
  dispatch(slice.actions.setCourseDetail(detail))
}

//Course Product

// only one product at a time
// courseProduct = {
//   "actualPricePerEach": 0,
//   "actualPriceTotal": 0,
//   "amount": 0,
//   "productId": 0
// }
export const addCourseProduct = (id, courseProduct) => async (dispatch) => {
  const detail = await courseApi.addBatchProduct(id, [courseProduct])
  dispatch(slice.actions.setCourseDetail(detail))
}

export const editCourseProduct = (
  courseId,
  courseProductI,
  courseProduct
) => async (dispatch) => {
  const detail = await courseApi.editProduct(
    courseId,
    courseProductI,
    courseProduct
  )
  dispatch(slice.actions.setCourseDetail(detail))
}

//number id
//number courseProductId
export const deleteCourseProduct = (
  courseId = 0,
  courseProductId = 0
) => async (dispatch) => {
  const detail = await courseApi.deleteProduct(courseId, courseProductId)
  dispatch(slice.actions.setCourseDetail(detail))
}

// Course Recode

// const courseRecordDto = {
//   "amount": 0,
//   "comment": "string",
//   "courseId": 0,
//   "courseProductId": 0,
//   "operatorId": 0,
//   "recordDateTime": "yyyy/MM/dd hh:mm:ss"
// }
export const addCourseRecord = (
  courseId,
  courseRecordDto,
  employeeId,
  phoneNumber
) => async (dispatch) => {
  const detail = await courseApi.addCourseRecord(
    courseId,
    courseRecordDto,
    employeeId,
    phoneNumber
  )
  dispatch(slice.actions.setCourseDetail(detail))
}

export const editCourseRecord = (courseId, index, courseRecordDto) => async (
  dispatch
) => {
  const detail = await courseApi.editCourseRecord(
    courseId,
    index,
    courseRecordDto
  )
  dispatch(slice.actions.setCourseDetail(detail))
}

export const deleteCourseRecord = (courseId, index) => async (dispatch) => {
  const detail = await courseApi.deleteCourseRecord(courseId, index)
  dispatch(slice.actions.setCourseDetail(detail))
}

// Course Payment

// const paymentDto = {
//   "afterTax": 0,
//   "amount": 0,
//   "comment": "string",
//   "courseId": 0,
//   "info": "string",
//   "paymentMethodId": 0,
//   "recordDateTime": "string",
//   "tax": 0
// }
export const addCoursePayment = (courseId, paymentDto) => async (dispatch) => {
  const detail = await courseApi.addCoursePayment(courseId, paymentDto)
  dispatch(slice.actions.setCourseDetail(detail))
}

export const editCoursePayment = (courseId, id, paymentDto) => async (
  dispatch
) => {
  const detail = await courseApi.editCoursePayment(courseId, id, paymentDto)
  dispatch(slice.actions.setCourseDetail(detail))
}

export const deleteCoursePayment = (courseId, id) => async (dispatch) => {
  const detail = await courseApi.deleteCoursePayment(courseId, id)
  dispatch(slice.actions.setCourseDetail(detail))
}

// Modal
export const setModalViewName = (viewName) => (dispatch) => {
  dispatch(slice.actions.setModalViewName(viewName))
}

export const setModalViewParams = (params) => (dispatch) => {
  dispatch(slice.actions.setModalViewParams(params))
}

export const openModal = () => (dispatch) => {
  dispatch(slice.actions.openModal())
}

export const closeModal = () => (dispatch) => {
  dispatch(slice.actions.closeModal())
}


export const getCustomerContactById = (customerId) => async (dispatch) => {
  const contect = await customerApi.getCustomerById(customerId)
  dispatch(slice.actions.setCustomerContect(contect))
  return contect
}

export const sendSignatureMessage = (
  courseId,
  courseRecordDto,
  employeeId,
  phoneNumber,
  selectedIndex
) => async (dispatch) => {
  dispatch(slice.actions.setSelectedIndex(selectedIndex))
  const updateRecord = await customerApi.sendMessageToCustomer(
    courseId,
    courseRecordDto,
    employeeId,
    phoneNumber
  )
  // dispatch(slice.actions.setCustomerServiceProgressList(updateRecord.data))
  dispatch(slice.actions.setCourseDetail(updateRecord.data))
}

export const resetOlderSlice = () => (dispatch) => {
  dispatch(slice.actions.reset())
}

export default slice
